import { makeStyles } from 'tss-react/mui';

export const usePartnerReferralDetailsStyles = makeStyles({ name: 'PartnerReferralDetails' })((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  subTitle: {
    color: theme.palette.secondary.main,
    fontWeight: 700,
    fontSize: '12px',
    textTransform: 'uppercase',
  },
  weightBold: {
    fontWeight: 500,
  },
  noNote: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
}));
